import React from 'react';
import styled from '@emotion/styled';
import CardConfiguracaoUnidade from '../../../../components/CardConfiguracaoUnidade';

const CAMPOS_OBRIGATORIOS = {
  DATA_NASCIMENTO: 'dataNascimento',
  CPF: 'cpf',
  RG: 'rg',
  ENDERECO_RESIDENCIAL: 'endereco',
  CONVENIO: 'dadosConvenio',
  EMAIL: 'contato.contato_email',
  QUEM_INDICOU: 'quemIndicou',
};

const Paciente = ({ venda, configuracaoUnidade, onChange, disabled }) => {
  return (
    <Container>
      <GridContainer>
        <CardConfiguracaoUnidade
          title="Contato"
          configuracaoUnidade={configuracaoUnidade}
          onChange={onChange}
          disabled={disabled}
          fields={[
            { value: 'utilizaTelefoneInternacional', label: 'Utiliza telefone internacional?', type: 'switch' },
          ]}
        />

        <CardConfiguracaoUnidade
          title="Controle de sessão"
          configuracaoUnidade={configuracaoUnidade}
          onChange={onChange}
          disabled={disabled}
          fields={[
            { value: 'utilizaControleSessao', label: 'Permitir que os usuários tenham acesso a múltiplas sessões', type: 'switch' },
          ]}
        />
      </GridContainer>

      <FullWidth>
        <CardConfiguracaoUnidade
          title="Campos obrigatórios"
          configuracaoUnidade={configuracaoUnidade}
          onChange={onChange}
          disabled={disabled}
          fields={[
            { value: CAMPOS_OBRIGATORIOS.DATA_NASCIMENTO, label: 'Data de nascimento', type: 'switch' },
            { value: CAMPOS_OBRIGATORIOS.CPF, label: 'CPF', type: 'switch' },
            { value: CAMPOS_OBRIGATORIOS.RG, label: 'RG', type: 'switch' },
            { value: CAMPOS_OBRIGATORIOS.ENDERECO_RESIDENCIAL, label: 'Endereço residencial', type: 'switch' },
            { value: CAMPOS_OBRIGATORIOS.CONVENIO, label: 'Convênio', type: 'switch' },
            { value: CAMPOS_OBRIGATORIOS.EMAIL, label: 'Email', type: 'switch' },
            { value: CAMPOS_OBRIGATORIOS.QUEM_INDICOU, label: 'Quem indicou', type: 'switch' },
          ]}
        />
      </FullWidth>

      <GridContainer>
        <CardConfiguracaoUnidade
          title="Sobre o paciente"
          configuracaoUnidade={configuracaoUnidade}
          onChange={onChange}
          disabled={disabled}
          fields={[
            { value: 'permiteDuplicidadeCPF', label: 'Permite cadastrar pacientes com o mesmo CPF.', type: 'switch' },
          ]}
        />

        <CardConfiguracaoUnidade
          title="Quantidade de reagendamento"
          configuracaoUnidade={configuracaoUnidade}
          onChange={onChange}
          disabled={disabled}
          fields={[
            { value: 'utilizaReagendamento', label: 'Utiliza o monitoramento da quantidade de reagendamentos?', type: 'switch' },
            ...(configuracaoUnidade?.utilizaReagendamento
              ? [{
                  value: 'quantidadeReagendamentoSujeitoAtencao',
                  name: 'quantidadeReagendamentoSujeitoAtencao',
                  label: 'Quantidade de reagendamentos Permitidos.',
                  type: 'input',
                }]
              : []),
          ]}
        />

        <CardConfiguracaoUnidade
          title="Identificador personalizado do paciente?"
          configuracaoUnidade={configuracaoUnidade}
          onChange={onChange}
          disabled={disabled}
          fields={[
            { value: 'utilizaIdPersonalizadoPaciente', label: 'Utiliza o id personalizado do Paciente?', type: 'switch' },
          ]}
        />
      </GridContainer>
    </Container>
  );
};

export default Paciente;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FullWidth = styled.div`
  width: 100%;
`;
